import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { IoDocumentTextOutline } from "react-icons/io5";
import { saveAs } from "file-saver";
import { AiOutlineDownload } from "react-icons/ai";

const RequestView = ({ setRequestView, currentItem }) => {
  const { t } = useTranslation();
  const downloadFile = () => {
    saveAs(currentItem?.cvFile, "cvFile.pdf");
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[85vh] overflow-y-auto	">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("O_VIEW_USER")}</h3>
                <button className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none" onClick={() => setRequestView(false)}>
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <h3 className="text-xl font-semibold">Employee details</h3>
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employee name</strong>
                      <h6>{currentItem?.Employee?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employee email ID</strong>
                      <h6>{currentItem?.Employee?.email || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-6 w-full group">
                      <strong>Year of experience</strong>
                      <h6>{currentItem.yearOfExperiece || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>DOB</strong>
                      <h6>{dayjs(currentItem?.Employee?.dob).format("MM-DD-YYYY")}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Country</strong>
                      <h6>{currentItem?.EmployeeCountry?.name} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>State</strong>
                      <h6>{currentItem?.EmployeeState?.name} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>City</strong>
                      <h6>{currentItem.Employee?.city || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-6 w-full group">
                      <strong>Skills</strong>
                      <h6>{currentItem?.EmployeeSkills?.map((skill) => skill?.name).join(", ")}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job applied date</strong>
                      <h6>{dayjs(currentItem?.createdAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-6">
                {" "}
                <hr />
              </div>
              <div className="p-6 relative flex-auto">
                <h3 className="font-semibold text-xl ">Job details</h3>
                <div className="grid-cols-3 grid ">
                  <div className="sm:py-4 py-8 px-7 sm:px-2 ">
                    <div className="mb-2 w-full relative z-0 group">
                      <strong>Job Title</strong>
                      <h6>{currentItem?.Job?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Category</strong>
                      <h6>{currentItem?.JobCategory?.name || ""}</h6>
                    </div>
                  </div>

                  <div className="py-8 sm:py-4 sm:px-2 px-7">
                    <div className="group relative z-0 mb-2 w-full ">
                      <strong>Country</strong>
                      <h6>{currentItem?.JobCountry?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="py-8 px-7 sm:py-4 sm:px-2 ">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>City</strong>
                      <h6>{currentItem?.Job?.city || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Subcategory</strong>
                      <h6>{currentItem?.JobSubCategory?.name}</h6>
                    </div>
                  </div>
                  <div className="sm:px-2 py-8 sm:py-4 px-7">
                    <div className="relative mb-2 w-full z-0 group">
                      <strong>Department</strong>
                      <h6>{currentItem?.JobDepartment?.name} </h6>
                    </div>
                  </div>

                  <div className="px-7 sm:py-4 sm:px-2 py-8 ">
                    <div className="z-0 mb-2 w-full group relative ">
                      <strong>Skills</strong>
                      <h6>{currentItem?.JobSkills?.map((jobSkill) => jobSkill?.name).join(", ")}</h6>
                    </div>
                  </div>
                  <div className="py-8 sm:py-4 sm:px-2 px-7">
                    <div className=" w-full relative z-0 mb-2 group">
                      <strong>Employment length (In days)</strong>
                      <h6>{currentItem?.Job?.employmentLength}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Created date</strong>
                      <h6>{dayjs(currentItem?.Job?.createdAt).format("MM-DD-YYYY hh:mm A")} </h6>
                    </div>
                  </div>
                </div>
                <div className="grid">
                  <div className="sm:py-4 py-8 px-7 sm:px-2 ">
                    <div className="relative w-full z-0 mb-2 group">
                      <strong>Job description</strong>
                      <div className="inner-html" dangerouslySetInnerHTML={{ __html: currentItem?.Job?.description }} />
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Termination description</strong>
                      <div className="inner-html" dangerouslySetInnerHTML={{ __html: currentItem?.Job?.terminationCondition }} />
                    </div>
                  </div>
                  <div className="grid grid-cols-1">
                    <div className="sm:pt-4 sm:px-2 pt-8 pb-0 px-7">
                      <div className="relative z-0 mb-0 w-full group">
                        <strong className="mb-3 block">Resume</strong>
                        <div className="grid-cols-5 grid gap-x-4">
                          <div className="border-2 flex items-center rounded-lg p-3 justify-between">
                            <div className="overflow-hidden item object-cover ">
                              <span>
                                <IoDocumentTextOutline className="text-4xl" />
                              </span>
                            </div>
                            <button type="button" className="mb-2 py-2 bg-LightBlue text-sm px-2 mr-3 mt-2 ml-3 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue" title="Download" onClick={downloadFile}>
                              <AiOutlineDownload
                                style={{
                                  fontWeight: 800,
                                  width: "15px",
                                }}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => setRequestView(false)}>
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default RequestView;
